import { apiClient } from "rp-components"
import { GuestBookingDetails, GuestWaiverConfirmation } from "@/models/BookingEvent"

export interface GuestWaiverService {
    getGuestBooking(hash: string): Promise<GuestBookingDetails>
    confirmGuest(hash: string, details: GuestBookingDetails): Promise<void>
}

class GuestWaiverServiceImpl implements GuestWaiverService {
    static instance?: GuestWaiverService = undefined

    private constructor() {}

    static getInstance(): GuestWaiverService {
        if (GuestWaiverServiceImpl.instance == undefined) {
            GuestWaiverServiceImpl.instance = new GuestWaiverServiceImpl()
        }
        return GuestWaiverServiceImpl.instance
    }

    async getGuestBooking(hash: string): Promise<GuestBookingDetails> {
        return apiClient.get(`public/amenity-bookings/guests/${hash}`)
    }

    async confirmGuest(hash: string, details: GuestBookingDetails): Promise<void> {
        const payload: GuestWaiverConfirmation = {
            firstName: details.guest.firstName,
            lastName: details.guest.lastName,
            email: details.guest.email,
            invitationStatus: details.guest.invitationStatus ?? "pending",
            invitationTimestamp: details.guest.invitationTimestamp,
            primary: details.guest.primary ?? false
        }
        await apiClient.post(`public/amenity-bookings/guests/${hash}/confirm`, payload)
    }
}

export default GuestWaiverServiceImpl.getInstance()
